<template>
  <div class="mt-8">
    <ModalGlobal
      id="modalPaypalSuccess"
      class="modalPaypalSuccess superimpose hideCloseBtn hidden"
    >
      <template #dialogHeadImg>
        <img
          class="absolute h-22 -top-12 left-0 right-0 m-auto pointer-events-none"
          src="https://photo-public.s3.amazonaws.com/suf/home/photo-pass-logo.png"
          alt="logo photo"
        />
      </template>

      <template #dialogHeading>{{
        $t("messages.paypal_success_thank_you")
      }}</template>

      <template #dialogDescription>
        <div class="text-center">
          <span class="font-semibold">
            {{ $t("messages.paypal_success_thank_you_description") }}
          </span>
        </div>
      </template>
    </ModalGlobal>

    <ModalGlobal
      id="modalPaypalError"
      class="modalPaypalError superimpose hideCloseBtn hidden"
    >
      <template #dialogHeadImg>
        <img
          class="absolute h-22 -top-12 left-0 right-0 m-auto pointer-events-none"
          src="https://photo-public.s3.amazonaws.com/suf/home/photo-pass-logo.png"
          alt="logo photo"
        />
      </template>

      <template #dialogHeading>{{ $t("messages.paypal_error_head") }}</template>

      <template #dialogDescription>
        <div class="text-center">
          <span
            class="font-semibold"
            v-html="$t('messages.paypal_error_body')"
          ></span>
          <br />
          <span
            class="font-semibold"
            v-html="$t('messages.paypal_error_transaction_status')"
          ></span>
          <span id="paypal_error_transaction_status"></span>
          <br />
          <span
            class="font-semibold"
            v-html="$t('messages.paypal_error_transaction_id')"
          ></span>
          <span id="paypal_error_transaction_id"></span>
          <!-- ,
                    si esto no sucede
                    <a id="linkRedirectPaypal" class="underline text-link-blue font-semibold" href="">¡haz clic aquí!</a>! -->
        </div>
      </template>

      <button
        @click.prevent="closeModalPaypalError()"
        type="button"
        class="w-full flex justify-center rounded-full py-3 px-4 mb-1 border-yellow-photo border bg-yellow-photo cursor-pointer font-semibold mx-auto"
      >
        {{ $t("gallery.vd.close") }}
      </button>
    </ModalGlobal>

    <ModalGlobal
        id="modalSaleError"
        class="modalSaleError superimpose hideCloseBtn hidden"
      >
        <template #dialogHeadImg>
          <img
            class="absolute h-22 -top-12 left-0 right-0 m-auto pointer-events-none"
            src="https://photo-public.s3.amazonaws.com/suf/home/photo-pass-logo.png"
            alt="logo photo"
          />
        </template>

        <template #dialogHeading>{{ $t("modalSaleError.title") }}</template>

        <template #dialogDescription>
          <div class="text-left">
            <span class="font-semibold" v-html="$t('modalSaleError.message')">
              
            </span>
          </div>
        </template>

        <button
          @click.prevent="closeModalSaleError()"
          type="button"
          class="w-full flex justify-center rounded-full py-3 px-4 mb-1 border-yellow-photo border bg-yellow-photo cursor-pointer font-semibold mx-auto"
        >
          {{ $t("gallery.vd.close") }}
        </button>
      </ModalGlobal>

    <template v-if="$store.state.shoppingCartAmount">
      <div
        class="headerClass flex flex-col md:flex-row border-b border-yellow-photo pb-4 mb-4 container mx-auto items-center px-4 md:px-8"
      >
      <template v-for="(item, idx) in $store.state.shoppingCart">
        <div :key="idx" class="md:flex items-center hidden">
          <img  
            :src="item.isEvent ? item.eventDetails.Resources.Logo : 'https://photo-public.s3.amazonaws.com/suf/home/photo-pass-logo.png'"
            alt="logo parque"
            class="w-auto h-18"
          />
        </div>
      </template>
        <div
          class="flex flex-col flex-1 md:pl-4 items-center md:items-start text-3xl font-bold text-black"
        >
          {{ $t("Forms.your_purchase") }}
        </div>
      </div>

      <!-- <section class="container mx-auto flex flex-wrap"> -->
      <ValidationObserver
        v-slot="{ handleSubmit }"
        class="container mx-auto flex flex-wrap"
      >
        <template v-for="(item, idx) in $store.state.shoppingCart">
          <div class="md:flex flex-1 items-center mb-4">
            <router-link :key="idx"
              class="cursor-pointer bg-green-xcaret text-white px-4 py-1"
              :to="{ name: 'albumes'}"
              v-if="!item.isEvent"
            >
              <span class="pointer-events-none">
                <span class="material-icons"> arrow_back </span>
                {{ $t("messages.my_albumes") }}
              </span>
            </router-link>
            <a 
              @click="cleanShoppingCart"
              class="cursor-pointer bg-green-xcaret text-white px-4 py-1"
            v-else>
            <span class="pointer-events-none">
                <span class="material-icons"> arrow_back </span>
                {{ $t("triatlon.back") }}
              </span>
            </a>
            <span class="material-icons mx-4"> chevron_right </span>
            <span>
              <span class="pointer-events-none underline">
                {{ $t("Forms.your_purchase") }}
              </span>
            </span>
          </div>
        </template>

        <form
          class="w-full buyerData"
          @submit.prevent="handleSubmit(Payment)"
          autocomplete="false"
        >
          <input type="hidden" v-model="MakeFullName" />
          <div class="container mx-auto flex flex-wrap">
            <div
              style="z-index: 1"
              class="flex flex-col w-full md:w-3/5 px-4 animate__animated animate__fadeIn"
              v-show="currentStep === 3"
            >
              <div id="challengeFormContainer"></div>
            </div>
            <div
              style="z-index: 1"
              class="flex flex-col w-full md:w-3/5 px-4 animate__animated animate__fadeIn"
              v-show="currentStep !== 3"
            >
              <ValidationObserver v-if="currentStep === 1">
                <div class="uppercase font-bold mb-2 text-black">
                  {{ $t("Forms.buyer_data") }}
                </div>
                <span class="text-xs">{{ $t("Forms.needed_data") }}</span>
                <div class="flex flex-wrap mx-auto my-4">
                  <div class="w-full md:w-1/2 flex flex-col mb-3 px-2">
                    <ValidationProvider
                      :name="$t('Forms.firstname')"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <label class="font-bold" :for="$t('Forms.firstname')">
                        {{ $t("Forms.firstname") }}*
                      </label>
                      <input
                        v-model="Buyer.FirstName"
                        type="text"
                        :id="$t('Forms.firstname')"
                        class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg"
                        :class="[errors.length && 'border-newxcaret-red']"
                      />
                      <p class="txt-error text-red text-xs italic">
                        {{ errors[0] }}
                      </p>
                      <!-- <span>{{ errors[0] }}</span> -->
                    </ValidationProvider>
                  </div>
                  <div class="w-full md:w-1/2 flex flex-col mb-3 px-2">
                    <ValidationProvider
                      :name="$t('Forms.lastname')"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <label class="font-bold" :for="$t('Forms.lastname')">
                        {{ $t("Forms.lastname") }}*
                      </label>
                      <input
                        v-model="Buyer.LastName"
                        type="text"
                        :id="$t('Forms.lastname')"
                        class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg"
                        :class="[errors.length && 'border-newxcaret-red']"
                      />
                      <p class="txt-error text-red text-xs italic">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>

                  <div class="w-full md:w-1/2 flex flex-col mb-3 px-2">
                    <ValidationProvider
                      :name="$t('Forms.email')"
                      rules="required|email"
                      v-slot="{ errors }"
                    >
                      <label class="font-bold" :for="$t('Forms.email')">
                        {{ $t("Forms.email") }}*
                      </label>
                      <input
                        v-model="Buyer.Email"
                        type="email"
                        :id="$t('Forms.email')"
                        class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg"
                        :class="[errors.length && 'border-newxcaret-red']"
                      />
                      <p class="txt-error text-red text-xs italic">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>
                  <div class="w-full md:w-1/2 flex flex-col mb-3 px-2">
                    <ValidationProvider
                      :name="$t('Forms.phone')"
                      rules="required|numeric"
                      v-slot="{ errors }"
                    >
                      <label class="font-bold" :for="$t('Forms.phone')">
                        {{ $t("Forms.phone") }}*
                      </label>
                      <input
                        v-model="Buyer.phone"
                        @keypress="onlyNumber"
                        type="tel"
                        :id="$t('Forms.phone')"
                        :maxlength="14"
                        trim
                        class="w-full h-10 p-3 my-2 border border-newxcaret-blue bg-white rounded-lg"
                        :class="[errors.length && 'border-newxcaret-red']"
                      />
                      <p class="txt-error text-red text-xs italic">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>
                  <div class="w-full md:w-1/2 flex flex-col mb-3 px-2">
                    <ValidationProvider
                      :name="$t('Forms.country')"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <label class="font-bold" :for="$t('Forms.country')">
                        {{ $t("Forms.country") }}*
                      </label>

                      <multiselect
                        v-model="Buyer.country"
                        :name="$t('Forms.country')"
                        :options="Contries"
                        :multiple="false"
                        :searchable="true"
                        track-by="id"
                        label="name"
                        :close-on-select="true"
                        :clear-on-select="false"
                        :hide-selected="true"
                        :allow-empty="false"
                        :showNoResults="false"
                        :showNoOptions="false"
                        open-direction="bottom"
                        :selectLabel="''"
                        placeholder=""
                        />
                 
                      <p class="txt-error text-red text-xs italic">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>
                  <div class="w-full md:w-1/2 flex flex-col mb-3 px-2">
                    <ValidationProvider
                      :name="$t('Forms.state')"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <label class="font-bold" :for="$t('Forms.state')">
                        {{ $t("Forms.state") }}*
                      </label>
                      <multiselect
                        v-model="Buyer.states"
                        :disabled="!Buyer?.country?.id"
                        :name="$t('Forms.state')"
                        :options="getCountryStates"
                        :multiple="false"
                        :searchable="true"
                        track-by="id"
                        label="name"
                        :close-on-select="true"
                        :clear-on-select="false"
                        :hide-selected="true"
                        :allow-empty="false"
                        :showNoResults="false"
                        :showNoOptions="false"
                        open-direction="bottom"
                        :selectLabel="''"
                        placeholder=""
                        />
                      <p class="txt-error text-red text-xs italic">
                        {{ errors[0] }}
                      </p>
                    </ValidationProvider>
                  </div>
                  <div class="my-4 hidden">
                    <div class="ml-4 text-sm">
                      <input class="-ml-4" id="checkBuyer" type="checkbox" />
                      <label for="checkBuyer" class="ml-1 text-grey">
                        {{ $t("Forms.dif_visitor") }}
                      </label>
                    </div>
                    <div class="ml-4 text-sm">
                      <input class="-ml-4" id="checkLegal" type="checkbox" />
                      <label for="checkLegal" class="ml-1 text-grey">
                        {{ $t("Forms.adult_agree") }}
                      </label>
                    </div>
                    <div class="ml-4 text-sm">
                      <input class="-ml-4" id="checkRecieve" type="checkbox" />
                      <label for="checkRecieve" class="ml-1 text-grey">
                        {{ $t("Forms.promo_agree") }}
                      </label>
                    </div>
                  </div>
                  <div class="flex w-full">
                    <a
                      class="hidden flex justify-center items-center rounded-full py-2 w-1/2 mx-2 my-2 bg-white text-black border border-black cursor-pointer"
                    >
                      {{ $t("Forms.back") }}
                    </a>
                    <div
                      class="flex justify-center items-center rounded-full py-2 w-1/2 mx-2 my-2 bg-white text-black"
                    >
                      &nbsp;
                    </div>
                    <button
                      type="submit"
                      class="flex justify-center items-center rounded-full py-2 w-1/2 mx-2 my-2 bg-yellow-photo cursor-pointer"
                    >
                      {{ $t("Forms.continue") }}
                    </button>
                  </div>
                </div>
              </ValidationObserver>

              <ValidationObserver v-if="currentStep === 2">
                <div class="uppercase font-bold mb-2 text-black">
                  {{ $t("Forms.select_payment_method") }}
                </div>
                <ul
                  class="payment_method flex flex-nowrap md:flex-wrap items-start justify-around border py-2 mx-auto md:w-9/10"
                >
                  <li
                    @click="PaymentMethod = 0"
                    class="items-center justify-center px-2 flex flex-col flex-auto items-center h-12"
                  >
                    <input
                      v-model="PaymentMethod"
                      type="radio"
                      id="radiotarjeta"
                      name="payments_radio"
                      :value="0"
                    />
                    <label class="flex flex-col text-xs" for="radiotarjeta">
                      {{ $t("Forms.card") }}
                      <svg
                        class="icon-card svg-inline--fa fa-credit-card pointer-events-none"
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="credit-card"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 576 512"
                      >
                        <path
                          class=""
                          fill="currentColor"
                          d="M512 32C547.3 32 576 60.65 576 96V128H0V96C0 60.65 28.65 32 64 32H512zM576 416C576 451.3 547.3 480 512 480H64C28.65 480 0 451.3 0 416V224H576V416zM112 352C103.2 352 96 359.2 96 368C96 376.8 103.2 384 112 384H176C184.8 384 192 376.8 192 368C192 359.2 184.8 352 176 352H112zM240 384H368C376.8 384 384 376.8 384 368C384 359.2 376.8 352 368 352H240C231.2 352 224 359.2 224 368C224 376.8 231.2 384 240 384z"
                        ></path>
                      </svg>
                    </label>
                  </li>

                  <li
                    @click="PaymentMethod = 1"
                    class="items-center justify-center px-2 flex flex-col flex-auto items-center h-12"
                    v-if="$store.getters.hasPayPal"
                    >
                    <input
                      type="radio"
                      v-model="PaymentMethod"
                      id="radiopaypal"
                      name="payments_radio"
                      :value="1"
                    />
                    <label class="flex flex-col text-xs" for="radiopaypal">
                      PayPal
                      <img
                        src="https://photo-public.s3.amazonaws.com/suf/payment-method/pp.svg"
                        class="w-full h-auto max-w-10 max-h-8 inline-block object-cover"
                      />
                    </label>
                  </li>

                  <li
                    class="hidden items-center justify-center px-2 flex flex-col flex-auto items-center h-12"
                  >
                    <input
                      type="radio"
                      v-model="PaymentMethod"
                      id="radiodeposito"
                      name="payments_radio"
                      value="Depósito"
                    />
                    <label class="flex flex-col text-xs" for="radiodeposito">
                      {{ $t("shopping_cart.deposit") }}
                    </label>
                  </li>

                  <li
                    class="hidden items-center justify-center px-2 flex flex-col flex-auto items-center h-12"
                  >
                    <input
                      type="radio"
                      id="radiotransferencia"
                      name="payments_radio"
                      value="Transferencia"
                    />
                    <label
                      class="flex flex-col text-xs"
                      for="radiotransferencia"
                    >
                      {{ $t("shopping_cart.transfer") }}
                    </label>
                  </li>

                  <li
                    class="hidden items-center justify-center px-2 flex flex-col flex-auto items-center h-12"
                  >
                    <input
                      type="radio"
                      id="radioconveniencia"
                      name="payments_radio"
                      value="Tienda de conveniencia"
                    />
                    <label
                      class="flex flex-col text-xs"
                      for="radioconveniencia"
                    >
                      {{ $t("shopping_cart.convenience_store") }}
                    </label>
                  </li>
                </ul>
                <div
                  class="flex flex-wrap flex-col-reverse md:flex-row"
                  v-if="PaymentMethod == 0"
                >
                  <div
                    class="flex flex-wrap mx-auto my-4 text-black w-full md:w-3/4"
                  >
                    <div class="w-full flex flex-col px-2">
                      <ValidationProvider
                        :name="$t('Forms.card_number')"
                        rules="required|numeric|min:8"
                        v-slot="{ errors }"
                      >
                        <label class="font-semibold">
                          {{ $t("Forms.credit_debit_card_number") }}*
                        </label>
                        <input
                          v-model="PaymentMethods.card"
                          type="text"
                          @keypress="onlyNumber"
                          @focus="removeAttribute($event)"
                          ref="field"
                          @blur="CardType()"
                          :maxlength="19"
                          trim
                          autocomplete="nope"
                          class="w-full h-10 px-3 my-2 border border-newxcaret-blue bg-white rounded"
                          :class="[errors.length && 'border-newxcaret-red']"
                          readonly
                        />
                        <p class="txt-error text-red text-xs italic">
                          {{ errors[0] }}
                        </p>
                      </ValidationProvider>
                    </div>

                    <div class="w-1/4 flex flex-col px-2">
                      <label class="font-semibold" for="validFor1">
                        {{ $t("Forms.expiry_date") }}*
                      </label>
                      <div
                        class="flex flex-wrap mx-auto my-4 text-black w-full no-margin"
                      >
                        <ValidationProvider
                          name="Mes de caducidad"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <select
                            id="validFor1"
                            v-model="PaymentMethods.expireMonth"
                            class="w-full h-10 px-3 my-2 border border-newxcaret-blue bg-white rounded"
                            :class="[errors.length && 'border-newxcaret-red']"
                          >
                            <option :value="null">
                              {{ $t("Forms.choose_option") }}
                            </option>
                            <option
                              v-for="(item, idx) in expiryDate.months"
                              :key="idx"
                              :value="item"
                            >
                              {{ item }}
                            </option>
                          </select>
                        </ValidationProvider>
                      </div>
                    </div>

                    <div class="w-1/4 flex flex-col px-2">
                      <label class="font-semibold" for="validFor2">
                        &nbsp;
                      </label>
                      <div
                        class="flex flex-wrap mx-auto my-4 text-black w-full no-margin"
                      >
                        <ValidationProvider
                          name="&nbsp;"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <select
                            id="validFor2"
                            v-model="PaymentMethods.expireYear"
                            class="w-full h-10 px-3 my-2 border border-newxcaret-blue bg-white rounded"
                            :class="[errors.length && 'border-newxcaret-red']"
                          >
                            <option :value="null">
                              {{ $t("Forms.choose_option") }}
                            </option>
                            <option
                              v-for="(item, idx) in expiryDate.years"
                              :key="idx"
                              :value="getYear(item)"
                            >
                              {{ item }}
                            </option>
                          </select>
                        </ValidationProvider>
                      </div>
                    </div>

                    <div class="w-1/2 flex flex-col px-2">
                      <ValidationProvider
                        :name="$t('Forms.cvv')"
                        rules="required|numeric|min:3|max:4"
                        v-slot="{ errors }"
                      >
                        <label class="font-semibold" for="codeFor">
                          {{ $t("Forms.cvv") }}*
                        </label>
                        <input
                          v-model="PaymentMethods.cvc"
                          @keypress="onlyNumber"
                          type="password"
                          :maxlength="4"
                          trim
                          id="codeFor"
                          placeholder="CVV"
                          class="w-full h-10 px-3 my-2 border border-newxcaret-blue bg-white rounded"
                          :class="[errors.length && 'border-newxcaret-red']"
                        />
                        <p class="txt-error text-red text-xs italic">
                          {{ errors[0] }}
                        </p>
                      </ValidationProvider>
                    </div>

                    <div
                      class="w-full md:w-1/2 flex flex-col px-2"
                      v-if="Banks.length > 1"
                    >
                      <ValidationProvider
                        :name="$t('Forms.bank')"
                        rules="required|numeric"
                        v-slot="{ errors }"
                      >
                        <label class="font-semibold" for="bankFor">
                          {{ $t("Forms.bank") }}
                        </label>

                        <select
                          id="bankFor"
                          v-model="PaymentMethods.bank"
                          class="w-full h-10 px-3 my-2 border border-newxcaret-blue bg-white rounded"
                          :class="[errors.length && 'border-newxcaret-red']"
                        >
                          <option :value="null">
                            {{ $t("Forms.choose_option") }}
                          </option>
                          <option
                            v-for="(item, idx) in Banks"
                            :key="idx"
                            :value="item.idBank"
                          >
                            {{ item.bankName }}
                          </option>
                        </select>
                        <p class="txt-error text-red text-xs italic">
                          {{ errors[0] }}
                        </p>
                      </ValidationProvider>
                    </div>

                    <template v-if="CardInfo.Type === 'CREDIT'">
                      <template v-if="Bank">
                        <div
                          class="w-full flex flex-col px-2"
                          v-if="hasMSIBank"
                        >
                          <label class="font-semibold" for="bankFor">
                            {{ $t("Forms.msi") }}
                          </label>

                          <div class="example column is-12 mt-2">
                            <label
                              class="radio is-inline"
                              v-for="(item, idx) in Bank.bankInstallments"
                              :key="idx"
                              :class="[idx && 'ml-3']"
                            >
                              <input
                                v-model="MSI"
                                type="radio"
                                name="activity"
                                class="radio-input"
                                :value="item.installments"
                                aria-required="true"
                                aria-invalid="true"
                              />
                              <span class="radio-label">
                                {{ item.installmentName }}
                              </span>
                            </label>
                          </div>
                          <p class="txt-error text-red text-xs italic">
                            {{ errors[0] }}
                          </p>
                          <!-- </ValidationProvider> -->
                        </div>
                      </template>
                    </template>

                    <div class="my-4">
                      <div class="ml-4 text-sm">
                        <ValidationProvider
                          :name="$t('Forms.terms_of_use')"
                          rules="required"
                        >
                          <input
                            v-model="Terms"
                            class="-ml-4"
                            id="checkRead"
                            type="checkbox"
                          />
                          <label
                            for="checkRead"
                            class="ml-1 text-grey"
                            v-html="$t('Forms.terms_of_use')"
                          ></label>
                          <!-- <span class="radio-label">
                                                        {{ errors[0] }}
                                                    </span> -->
                        </ValidationProvider>
                      </div>
                    </div>
                    <div class="flex w-full">
                      <a
                        @click="prevStep"
                        class="flex justify-center items-center rounded-full py-2 w-1/2 mx-2 my-2 bg-white text-black border border-black cursor-pointer"
                      >
                        {{ $t("Forms.back") }}
                      </a>
                      <button
                        type="submit"
                        :title="!Terms && $t('Forms.terms_of_use')"
                        :disabled="!Terms && 'disabled'"
                        class="flex justify-center items-center rounded-full py-2 w-1/2 mx-2 my-2 bg-yellow-photo cursor-pointer"
                        v-if="currentStep === 2 && PaymentMethod == 0"
                      >
                        {{ $t("cart.pay") }}
                      </button>
                    </div>
                  </div>
                  <div class="flex w-full md:w-1/4 shrink-0 px-4 items-start">
                    <img
                      class="w-full"
                      src="https://photo-public.s3.amazonaws.com/suf/card.png"
                      alt="card"
                    />
                  </div>
                </div>
              </ValidationObserver>
              <div
                class="flex flex-wrap flex-col-reverse md:flex-row"
                v-show="PaymentMethod == 1"
              >
                <div class="flex flex-wrap mx-auto my-4 text-black w-full">
                  <div class="mx-auto pt-4" id="paypal-button-container"></div>
                </div>
                <div class="my-4">
                  <div class="ml-4 text-sm">
                      <input
                        v-model="Terms"
                        class="-ml-4"
                        id="checkReadPaypal"
                        type="checkbox"
                      />
                      <label
                        for="checkReadPaypal"
                        class="ml-1 text-grey"
                        v-html="$t('Forms.terms_of_use')"
                      >
                      </label>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="flex flex-col items-center w-full md:w-2/5 px-4 md:border-l border-yellow-photo animate__animated animate__fadeIn animate__delay-1s"
            >
              <template v-for="(item, idx) in $store.state.shoppingCart">
                <div :key="idx" v-if="item.type == 3">
                  <div
                    class="flex mx-2 px-2 py-2 relative border-yellow-photo border-b"
                    :key="idx"
                  >
                    <img
                      :src="
                        'https://photo-public.s3.amazonaws.com/suf/logos/albumes/covers/park-' +
                        item.VideoDetails.parkId +
                        '.jpg'
                      "
                      alt=""
                      class="w-1/5 rounded"
                    /> 
                    <div class="flex flex-col flex-auto justify-center px-2">
                      <span class="font-bold uppercase mb-1">
                        {{ item.Name }}
                      </span>
                      <div class="flex text-xs">
                        <div class="flex flex-col flex-auto">
                          <span> {{ $t("gallery.tag") }} {{ item.Tag }} </span>
                          <span>
                            {{ dateString(item.date) }}
                          </span>
                        </div>
                        <span class="flex font-semibold items-end">
                          {{ item.Amount | toCurrency }}
                          {{ $store.state.Currency }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Codigos De descarga -->
                <div
                  :key="idx"
                  class="border-yellow-photo border-b"
                  v-else-if="item.type == 0"
                >
                  <div class="flex px-4 text-sm mt-2 w-full" :key="idx">
                    <span class="font-bold mr-1">{{ $t("Forms.code") }}</span
                    >{{ item.code }} |
                    {{ $tc("messages.albumes", item.Parks.length) }}
                  </div>
                  <div
                    class="flex mx-2 px-2 py-2 relative"
                    v-for="(park, idx2) in item.Parks"
                    :key="idx2"
                  >
                    <img
                      :src="
                        'https://photo-public.s3.amazonaws.com/suf/logos/albumes/covers/park-' +
                        park.Park.Id +
                        '.jpg'
                      "
                      class="w-1/5 rounded"
                    />
                    <div class="flex flex-col flex-auto justify-center px-2">
                      <span class="font-bold uppercase mb-1">
                        {{ $t("gallery.fotos") }}
                        {{ getParkName(park.Park.Id) }}
                      </span>
                      <div class="flex text-xs">
                        <div class="flex flex-col flex-auto">
                          <span>
                            {{ park.TotalMedia }}
                            {{ $t("gallery.fotos") }}
                          </span>
                          <span>
                            {{ dateString(item.date) }}
                          </span>
                        </div>
                        <span class="flex font-semibold items-end">
                          {{ (item.Amount / item.Parks.length) | toCurrency }}
                          {{ $store.state.Currency }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Rooms -->
                <div
                  :key="idx"
                  class="border-yellow-photo border-b"
                  v-else-if="item.type == 2"
                >
                  <div class="flex px-4 text-sm mt-2 w-full" :key="idx">
                    <span class="font-bold mr-1">{{ $t("cart.room") }}</span
                    >{{ item.Room }} |
                    {{ $tc("messages.albumes", item.Parks.length) }}
                  </div>
                  <div
                    class="flex mx-2 px-2 py-2 relative"
                    v-for="(park, idx2) in item.Parks"
                    :key="idx2"
                  >
                    <img
                      :src="
                        'https://photo-public.s3.amazonaws.com/suf/logos/albumes/covers/park-' +
                        park.Park.Id +
                        '.jpg'
                      "
                      class="w-1/5 rounded"
                    />
                    <div class="flex flex-col flex-auto justify-center px-2">
                      <span class="font-bold uppercase mb-1">
                        {{ $t("gallery.fotos") }}
                        {{ getParkName(park.Park.Id) }}
                      </span>
                      <div class="flex text-xs">
                        <div class="flex flex-col flex-auto">
                          <span>
                            {{ park.TotalMedia }}
                            {{ $t("gallery.fotos") }}
                          </span>
                          <span>
                            {{ dateString(item.date) }}
                          </span>
                        </div>
                        <span class="flex font-semibold items-end">
                          {{ (item.Amount / item.Parks.length) | toCurrency }}
                          {{ $store.state.Currency }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Tags -->
                <div :key="idx" v-else>
                  <div
                    class="flex mx-2 px-2 py-2 relative border-yellow-photo border-b"
                    :key="idx"
                  >
                    <img
                      :src="'https://photo-public.s3.amazonaws.com/suf/logos/albumes/covers/park-' + item.ParkID + '.jpg' "
                      alt=""
                      class="w-1/5 rounded"
                    />
                    <div class="flex flex-col flex-auto justify-center px-2">
                      <span
                        class="font-bold uppercase mb-1"
                        v-if="item.ServiceID != null"
                      >
                        {{ item.Name }}
                      </span>
                      <span class="font-bold uppercase mb-1" v-else>
                        {{ $t("gallery.fotos") }}
                        {{ getParkName(item.ParkID) }}
                      </span>

                      <div class="flex text-xs">
                        <div class="flex flex-col flex-auto">
                          <span v-if="item.Pax">{{
                            $tc("messages.pax", item.Pax)
                          }}</span>
                          <span v-else>{{
                            $tc("messages.albumes", item.cantidad)
                          }}</span>

                          <span>
                            {{ dateString(item.date) }}
                          </span>
                        </div>
                        <span class="flex font-semibold items-end">
                          {{ item.Amount | toCurrency }}
                          {{ $store.state.Currency }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <div
                class="flex flex-col items-end pt-3 border-t border-yellow-photo mx-4"
              >
                <div class="flex flex-col w-4/5">
                  <div class="hidden flex text-sm">
                    <span class="flex-auto">Subtotal:</span
                    ><span></span>
                  </div>
                  <div
                    class="flex font-bold pb-3 mb-4 border-b border-yellow-photo text-sm"
                  >
                    <span class="flex-auto">Total:</span>
                    <span>
                      {{ $store.state.payment.Amount | toCurrency }}
                      {{ $store.state.Currency }}
                    </span>
                  </div>

                  <div class="flex flex-col items-center">
                    <img
                      alt="msi"
                      class="w-32"
                      src="https://photo-public.s3.amazonaws.com/suf/payments/visa-master.png"
                    />
                    <p class="text-xs mb-4">
                      {{ $t("cart.banks") }}
                      <a class="text-link-blue" target="_blank" :href="$t('cart.main_cards_href')">
                        {{ $t("cart.main_cards") }}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </template>

    <p class="shopping-cart-empty big animate__animated animate__fadeIn" v-else>
      <center>
        <img
          src="https://photo-public.s3.amazonaws.com/suf/payments/shopping-cart-empty.webp"
          alt=""
        />
        <br />
        {{ $t("cart.no_products") }}
        <br /><br />

        <router-link
          class="text-center p-1 text-white rounded-full text-sm p-3 mt-8 text-grey border border-newxcaret-blue"
          :to="{
            name: 'albumes',
          }"
        >
          {{ $t("cart.back_album") }}
        </router-link>
      </center>
    </p>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import "../validators/index";

import Multiselect from 'vue-multiselect';

import PaypalCheckout from "../payment/Paypal-Checkout.vue";
import AlbumesMix from "../mixins/Albumes";
import Cart from "../mixins/Cart";
import PayPalMix from "../mixins/shoppingCart/Paypal";
import ShoppingCart from "../mixins/ShoppingCart";
import methodUser from "../mixins/methodUser";

import countries from "../logic/payment/Countries";
import CountriesStates from "../logic/payment/CountriesStates";

import _3DSMix from "../mixins/shoppingCart/3ds";
import BookingMix from "../mixins/shoppingCart/Booking";

import { loadScript } from "@paypal/paypal-js";
import PaypalCredentials from "../logic/payment/Paypal";

export default {
  mixins: [_3DSMix, BookingMix, AlbumesMix, Cart, PayPalMix, ShoppingCart, methodUser],
  components: {
    PaypalCheckout, Multiselect
  },
  data: () => ({
    options: [],
    modalPaypalSuccess: false,
    key: 1,
    location: location.origin,
    errors: [],
    CardInfo: {},
    Bank: {},
    MSI: 1,
    expiryDate: {
      months: [],
      years: [],
    },
    Localization: {},
    Step: {
      Buyer: 1,
    },
    currentStep: 1,
    Buyer: {
      FirstName: "",
      LastName: "",
      FullName: "",
      Email: "",
      phone: "",
      country: null,
      states: null,
      paymentMethod: "",
    },
    PaymentMethods: {
      card: "",
      expiry: "",
      cvc: "",
      bank: null,
      type: "",
      expireMonth: null,
      expireYear: null,
    },
    PaymentMethod: 0,
    Terms: false,
    CodeBankSafety: 0,
    SavePaymentArg: [],
  }),
  watch: {
    "Buyer.country": function () {
      this.Buyer.states = null;

      if (!this.Buyer?.country?.id) this.setCountryStates([]);
      else this.getCountryStatesData(this.Buyer?.country?.iSO);
    },
    "Buyer.FirstName": function (val) {
      this.Buyer.FirstName = this.UpperCaseFirstLetter(val);
    },
    "Buyer.LastName": function (val) {
      this.Buyer.LastName = this.UpperCaseFirstLetter(val);
    },
    "Buyer.Email": function (val) {
      this.Buyer.Email = val.toLowerCase();
    },
    "PaymentMethods.bank": function (val) {
      this.MSI = 1;
      this.filterCurrentBank();
    },
  },
  computed: {
    // Acceder al state de 'auth' module
    ...mapState('auth', ['modalAuth', 'user']),
    // Usar getters de 'auth' module
    ...mapGetters('auth', ['getModalAuth', 'getUser']),
    MakeFullName() {
      this.Buyer.FullName = this.Buyer.FirstName + " " + this.Buyer.LastName;

      return this.Buyer.FullName;
    },
    // Computed function to check if there is MSI in the chosen bank
    hasMSIBank() {
      return this.Bank.bankInstallments.length > 1;
    },
    GetErrors() {
      return this.errors;
    },
    useDataAccount() {
      this.Buyer.FirstName = this.getUser?.FirstName;
      this.Buyer.LastName = this.getUser?.LastName;
      this.Buyer.Email = this.getUser?.Email;
    },
  },
  methods: {
    // Usar acciones de 'auth' module
    ...mapActions('auth', ['setModalAuth', 'setUser']),
    removeAttribute(e) {
      e.target.removeAttribute("readonly");
    },
    // function getMonth with 1 parameter expecting date
    // This function returns a string of type MM (example: 05 = May)
    getMonth(m) {
      //get the month
      var month = m.getMonth();

      //increment month by 1 since it is 0 indexed
      //converts month to a string
      //if month is 1-9 pad right with a 0 for two digits
      month = (month + 1).toString().padStart(2, "0");

      return month;
    },
    // function getDay with 1 parameter expecting date
    // This function returns a string of type dd (example: 09 = The 9th day of the month)
    getDay(d) {
      //get the day
      //convert day to string
      //if day is between 1-9 pad right with a 0 for two digits
      var day = d.getDate().toString().padStart(2, "0");

      return day;
    },
    // function getYear with 1 parameter expecting date
    // This function returns the year in format yy (example: 21 = 2021)
    getYear(year) {
      //pull the last two digits of the year
      year = year.toString().substr(-2);

      return year;
    },
    getNextYears() {
      var date = new Date(),
        years = [],
        year = date.getFullYear();

      for (var i = year; i < year + 10; i++) {
        years.push(i.toString());
      }

      this.expiryDate.years = years;
    },
    getMonths() {
      let numberMonth = [];
      for (var i = 1; i < 13; i++) {
        let day = i.toString().padStart(2, "0");

        numberMonth.push(day);
      }

      this.expiryDate.months = numberMonth;
    },
    selectExternaBank() {
      const Bank = Object.values(this.$store.state.Banks).shift();
      this.Bank = Bank.idBank;

      this.filterCurrentBank();
    },
    filterCurrentBank() {
      let Bank = Object.values(this.$store.state.Banks)
        .filter((item) => item.idBank == this.PaymentMethods.bank)
        .shift();

      this.Bank = Bank;
    },
    nextStep() {
      if (this.currentStep === 2) {
        return;
      }

      this.currentStep++;
    },
    prevStep() {
      if (this.currentStep <= 0) {
        return;
      }

      this.currentStep--;
    },
    addSlashes(e) {
      let input = e.target.value.split("/").join(""); // Remove slash (/) if mistakenly entered.

      if (input.length < 5 && input.length > 0) {
        let finalVal = input.match(/.{1,2}/g).join("/");

        e.target.value = finalVal;
      }
    },
    cleanShoppingCart() {
      this.$store.dispatch('removeEventFromShoppingCart')
      this.$router.push({ name: "triatlon" });
    },
    //  Funcion para la obtencion de los Paises
    async getCountriesData() {
      try {
        let response = await countries.get();
        this.setContries(response.data.countries);
      } catch (error) {}
    },
    //  Funcion para la obtencion de las Ciudades confome su Pais
    async getCountryStatesData(iSO) {
      try {
        let response = await CountriesStates.get(iSO);
        this.setCountryStates(response.data.countryStates);
      } catch (error) {}
    },
    UpperCaseFirstLetter(string) {
      return string
        .split(" ")
        .map((letter) => {
          if (letter[0] != undefined) {
            return letter[0].toUpperCase() + letter.substring(1).toLowerCase();
          }
        })
        .join(" ");
    },
    removeSpace(string) {
      return string.replace(/\s/g, "");
    },
  },
  created() {
    if (!this.Contries.length) this.getCountriesData();

    this.$store.dispatch("getBanks", this.$store.state.Currency);

    this.options = this.$store.state.payment.countries.map((item) => {
      return {
        id: item.id,
        iSO: item.iSO,
        label: item.name,
      };
    });
  },
  async mounted() {
    let paypal;
    let paypalContainer = document.getElementById("paypal-button-container");
    let clientID = await PaypalCredentials.get();

    // Se intancia el evento postMessage antes que se genere la peticion
    this.eventPostMessageStepOne();

    try {
      paypal = await loadScript({
        "client-id": clientID,
        currency: this.$store.state.Currency,
        "disable-funding": "card",
      });
    } catch (error) {
      console.error("failed to load the PayPal JS SDK script", error);
    }

    if (paypal && paypalContainer) {
      try {
        await this.PayPalButtons();
      } catch (error) {
        console.error("failed to render the PayPal Buttons", error);
      }
    }

    if (this.Banks.length == 1) {
      this.PaymentMethods.bank = 109;
    }
    this.getNextYears();
    this.getMonths();
  },
};
</script>
